export const ANNUAL = 'ANNUAL' as const;
export const MONTHLY = 'MONTHLY' as const;
export const LIFETIME = 'LIFETIME' as const;
